import { render, staticRenderFns } from "./ppnmasukan.vue?vue&type=template&id=c9bf6cf4&scoped=true"
import script from "./ppnmasukan.vue?vue&type=script&lang=js"
export * from "./ppnmasukan.vue?vue&type=script&lang=js"
import style0 from "./ppnmasukan.vue?vue&type=style&index=0&id=c9bf6cf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9bf6cf4",
  null
  
)

export default component.exports